import React from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconFavorite, iconFavoriteBorder } from '@change-corgi/design-system-legacy/icons';

type LikeIconProps = {
	videoId: string;
};

export const LikeIcon: React.FC<LikeIconProps> = ({ videoId }) => {
	return (
		<Icon
			icon={iconFavoriteBorder}
			size="l"
			sx={{
				color: 'primary-black',
			}}
			data-testid={`supporter-video-${videoId}-like-icon`}
		/>
	);
};
export const UnLikeIcon: React.FC<LikeIconProps> = ({ videoId }) => {
	return (
		<Icon
			icon={iconFavorite}
			size="l"
			sx={{
				color: 'primary-changeRed',
			}}
			data-testid={`supporter-video-${videoId}-unlike-icon`}
		/>
	);
};
